<div class="card rounded border" *ngIf="member$ | async as member">
  <ng-container *ngIf="card$ | async as card">
    <div class="details-item">
      <label class="mb-0 font-size-12 text-white">{{ 'account.details.membership.number' | translate }}</label>
      <span class="font-size-12 text-white">{{ card.MemberSince }}</span>
    </div>
  </ng-container>
  <div class="details-item">
    <label class="mb-0 font-size-12 text-white">{{ 'account.details.dob' | translate }}</label>
    <div class="account-details-value">
      <span class="icon material-icons text-white" aria-hidden="true">date_range</span>
      <span class="font-size-12 text-white">{{ member.DOB | date: 'MMM d, yyy' }}</span>
    </div>
  </div>
  <div class="details-item">
    <label class="mb-0 font-size-12 text-white">{{ 'account.details.email' | translate }}</label>
    <div class="account-details-value">
      <span class="icon material-icons text-white" aria-hidden="true">email</span>
      <span class="font-size-12 text-white">{{ member.EmailAddress1 }}</span>
    </div>
  </div>
</div>
